import React from 'react';
import './parents.css';
import Navbar from '../components/navbar';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

const ParentInteractionProgramme = () => {
 return (
    <>
    <Navbar />
    <div className="pip-root">
      {/* Main Container */}
      <div className="pip-container">
                 <PageHeader 
                            title="Parent Interaction Programme"
                            crumbs={[
                              { label: 'Home', href: '/' },
                
                              { label: 'Parent Interaction Programme', href: '/Parent Interaction Programme' }
                            ]}
                          />
        {/* About Section */}
        <div className="pip-about-section">
          <div className="pip-section-title">About the Programme</div>
          <div className="pip-description">
            Programmes are organized by the Institute to inform parents about campus activities, 
            teaching processes, placement initiatives, and PD lectures. This forum ensures regular 
            reporting on academic results, attendance records, and internal exam performance to 
            foster student growth.
          </div>
          
          {/* Features Grid */}
          <div className="pip-features-grid">
            <div className="pip-feature-item">
              <svg className="pip-icon pip-icon-campus" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
              <span className="pip-feature-text">Campus Activities</span>
            </div>
            
            <div className="pip-feature-item">
              <svg className="pip-icon pip-icon-book" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.97 3.034l1.414 1.414-9.192 9.192A3.04 3.04 0 017.83 14.95a3.04 3.04 0 01-.694-3.65l9.286-9.284zm-1.414 2.414l-9.192 9.192a1.02 1.02 0 01-1.414 0l-1.414-1.414 9.192-9.192 1.414 1.414z"/>
              </svg>
              <span className="pip-feature-text">Teaching Process</span>
            </div>
            
            <div className="pip-feature-item">
              <svg className="pip-icon pip-icon-groups" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm0-8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
              </svg>
              <span className="pip-feature-text">100% Parent Engagement</span>
            </div>
            
            <div className="pip-feature-item">
              <svg className="pip-icon pip-icon-campaign" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 4h4v2h-3.6l2 2L13 8l-4-4v3H8V4zm8 8v6h-1.98l-1.2-4h-4.62l-1.2 4H6v-6h2v4h3.6l-1-4h-2.4l1.2-4H16v4h2z"/>
              </svg>
              <span className="pip-feature-text">PD Lectures & Workshops</span>
            </div>
            
            <div className="pip-feature-item">
              <svg className="pip-icon pip-icon-assessment" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 10H8v-1h8v1zm0-3H8V9h8v1zm0-3H8V6h8v1z"/>
              </svg>
              <span className="pip-feature-text">Result Reporting</span>
            </div>
            
            <div className="pip-feature-item">
              <svg className="pip-icon pip-icon-trending" viewBox="0 0 24 24" fill="currentColor">
                <path d="M13 7h-2v4h-4v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
              </svg>
              <span className="pip-feature-text">Placement Initiatives</span>
            </div>
            
            <div className="pip-feature-item">
              <svg className="pip-icon pip-icon-history" viewBox="0 0 24 24" fill="currentColor">
                <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/>
              </svg>
              <span className="pip-feature-text">Internal Exam Updates</span>
            </div>
            
            <div className="pip-feature-item">
              <svg className="pip-icon pip-icon-analytics" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.5 10h-4v-4h4v4zm6 0h-4v-4h4v4zm-6 4h-4v-2h4v2zm6 0h-4v-2h4v2z"/>
              </svg>
              <span className="pip-feature-text">Attendance Monitoring</span>
            </div>
            
            <div className="pip-feature-item">
              <svg className="pip-icon pip-icon-visibility" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
              </svg>
              <span className="pip-feature-text">Academic Transparency</span>
            </div>
          </div>
        </div>

        {/* Importance Section */}
        <div className="pip-importance-section">
          <div className="pip-importance-title">
            Why is the Parent Interaction Programme Important?
          </div>
          
          <div className="pip-importance-grid">
            {/* Card 1 */}
            <div className="pip-importance-card">
              <div className="pip-card-icon-wrapper">
                <svg className="pip-card-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm0-8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
                </svg>
              </div>
              <div className="pip-card-title">Identifying Strengths & Weaknesses</div>
              <div className="pip-card-description">
                By identifying specific strengths and weaknesses early, we can tailor support to 
                ensure better placement outcomes and overall career readiness for every student.
              </div>
            </div>

            {/* Card 2 */}
            <div className="pip-importance-card">
              <div className="pip-card-icon-wrapper">
                <svg className="pip-card-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>
                </svg>
              </div>
              <div className="pip-card-title">Faculty Interaction & Resolution</div>
              <div className="pip-card-description">
                Parents can interact directly with faculties to discuss concerns, resolve complaints, 
                and gain deeper insights into their child's classroom performance.
              </div>
            </div>

            {/* Card 3 - Images Card */}
            <div className="pip-images-card">
<div className="pip-images-grid">
  <div className="pip-image-item">
    <img 
      src="/images/Life/Parent_Interaction_Programme/session-1.jpg" 
      alt="Parent Interaction Programme Session" 
      style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }} 
    />
  </div>
  <div className="pip-image-item">
    <img 
      src="/images/Life/Parent_Interaction_Programme/session-2.jpg" 
      alt="Parents Interacting with Faculty" 
      style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }} 
    />
  </div>
</div>
              
            </div>
          </div>
        </div>
      </div>


    </div>
    <Footer />
    </>
  );
};

export default ParentInteractionProgramme;